import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSkiNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <clipPath id="sports_ski_normal_large_svg__a">
        <path d="M0 0h48v48H0z" />
      </clipPath>
      <g clipPath="url(#sports_ski_normal_large_svg__a)">
        <path
          d="M19.41 29.5L15.42 37h-.01v.02L9.57 48h6.92l6.38-11.99-1.13-2.13L20.08 37h-2.39l2.85-5.37zm-.4 9.5l-3.72 7H12.9l3.72-7zm9.58-13.75l8.68-16.31a7.566 7.566 0 00-.01-7.13l-.43-.8h-2.27l-9.43 17.73 1.13 2.13L28.32 17h2.39l-3.25 6.12zm.8-10.25l6.3-11.85A5.547 5.547 0 0135.5 8l-3.72 7zm9.04 33L28.29 28.93l-7.37-13.85V15h-.04L13.44 1.01h-2.27l-.43.8a7.566 7.566 0 00-.01 7.13L31.51 48zM12.5 8a5.547 5.547 0 01-.19-4.85L18.61 15h-2.39zm12.63 23.75L17.29 17h2.39l10.63 20h-2.39zM31.38 39l3.72 7h-2.39l-3.72-7z"
          fill=""
        />
      </g>
    </svg>
  )
);
SvgSportsSkiNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsSkiNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSkiNormalLarge;
